const closeBurgerMenu = () => {
    const burgerMenu = window.document.querySelector('.js-burger-menu');
    if (!burgerMenu)
        return;
    burgerMenu.classList.remove('active');
    window.document.body.classList.remove('open-burger-menu');
};
export default closeBurgerMenu;
